/**
 * Privacy Policy Page
 *
 * CMS-managed GDPR-compliant privacy policy with hardcoded fallback content.
 */

import { LegalPage } from '@/components/LegalPage';
import { DEFAULT_PRIVACY } from '../defaults/privacyDefaults';

export const PrivacyPolicyPage = () => (
    <LegalPage
        pageSlug="privacy"
        title="Privacy Policy"
        metaDescription="Privacy Policy for Stork Rentals - How we collect, use, and protect your personal data."
        defaults={DEFAULT_PRIVACY}
    />
);

export default PrivacyPolicyPage;
